<template>
    <div v-if="disabled"
            class="progress-bar progress progress-striped"
        >
        <div class="bar bar-disabled" style="width: 100%;"></div>
    </div>
    <div v-else 
        class="progress-bar progress">
        
        <div class="bar" role="progressbar"
             :class="{'bar-danger': hasError}"
             :style="toPercent(percent)" aria-valuemin="0" aria-valuemax="100"
        ></div>
    </div>
</template>

<script>
    // https://getbootstrap.com/2.3.2/components.html#progress
    // TODO: Add background options: https://getbootstrap.com/docs/4.3/components/progress/#backgrounds
    const LOAD_ERR = 101;

    export default {
        name: "ProgressBar",
        props: {
            percent: {
                type: Number,
                default: 0
            },
            disabled: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            hasError() {
                return this.percent == LOAD_ERR;
            }
        },
        methods: {
            toPercent(percent) {
                return "width: " + percent + "%;";
            }
        }
    }
</script>

<style>
.progress-bar .bar-disabled {
    background-color: #999;
}
</style>